import { DesignLayoutType } from '@graphql/generated';
import React from 'react';
import { UnlockDialogProvider } from '../UnlockDialog/UnlockDialogProvider';
import { SmartAppBannerProvider } from '@shared/components';
import { EventTopBar } from '../EventTopBar';
import { useIsMobileScreen } from '@shared/utils/media/useMediaScreens';
import { LayoutProvider } from '@shared/context/LayoutProvider';

interface StandAloneAlohaMenuProps
  extends Readonly<{
    readonly eventHandle: string;
  }> {}

export const StandAloneAlohaMenu: React.FC<StandAloneAlohaMenuProps> = ({ eventHandle }) => {
  const isMobile = useIsMobileScreen();

  if (isMobile) {
    return null;
  }

  return (
    <LayoutProvider layout={DesignLayoutType.aloha}>
      <SmartAppBannerProvider>
        <UnlockDialogProvider>
          <EventTopBar eventHandle={eventHandle} />
        </UnlockDialogProvider>
      </SmartAppBannerProvider>
    </LayoutProvider>
  );
};
